module.exports = __webpack_public_path__ + "static/media/震前有準備，現在沒有準備的原因.adb66bf2.xlsx";